import axios from 'axios';
import qs from 'query-string';
import { IItem } from '../store/state';

const SitevisionHeader = {
  'X-Requested-With': 'XMLHttpRequest',
  'Accept': 'application/json',
}
const BASE_URL = '';
export interface ISearchParams {
  query: string,
  numberToShow: number,
  tags: string,
  sortBy: string,
}
interface ISearchResObj {
  items: IItem[],
  total: number,
}

export const search = (url: string, params: ISearchParams): Promise<ISearchResObj> => {
  return axios.post(`${BASE_URL}${url}`, qs.stringify(params), { headers: { ...SitevisionHeader } })
    .then((response: any) => {
      return response.data
    })
    .catch((searchError: any) => {
      console.error(
        "ERROR:" + JSON.stringify(searchError)
      )
      return {} as ISearchResObj
    })
}